import {IntlMessage} from "multilanguagers/index";

const setNotifcation = (type, mode = 'classic', title = {}, text = {}, insert = 'top', duration = 4,reload=false,rewrite=false,landingpages='') => {
    if(document.querySelector('.alert-box') !== null && document.querySelector('.alert-box') !== undefined) {
        document.querySelector('.alert-box').remove()
    }
    let notification = document.createElement('div');
    notification.classList.add('alert-box')
    notification.classList.add(type)



    switch (insert) {
        case 'top':
            notification.style.top = '0'
            notification.style.transform = 'translateX(50%)'
            notification.style.right = '50%'
            break;
        case 'top right':
            notification.style.top = '0'
            notification.style.right = '0'
            break;
        case 'top left':
            notification.style.top = '0'
            notification.style.left = '0'
            break;
        case 'bottom':
            notification.style.bottom = '0'
            notification.style.transform = 'translateX(50%)'
            notification.style.right = '50%'
            break;
        case 'bottom right':
            notification.style.bottom = '0'
            notification.style.right = '0'
            break;
        case 'bottom left':
            notification.style.bottom = '0'
            notification.style.left = '0'
            break;
        case 'center left':
            notification.style.top = '35%'
            notification.style.transform = 'translateY(50%)';
            notification.style.left = '0'
            break;
        case 'center right':
            notification.style.top = '35%'
            notification.style.transform = 'translateY(50%)';
            notification.style.right = '0'
            break;
        default:
            notification.style.top = '0'

    }


    let icon;
    let durationcolor;
    switch (type) {
        case 'success':
            icon = '<svg xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 0 24 24" width="48px" fill="white">' +
                '<path d="M0 0h24v24H0V0z" fill="none"/><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm4.59-12.42L10 14.17l-2.59-2.58L6 13l4 4 8-8z"/>' +
                '</svg>';
            durationcolor = '--duration: ' + duration + ';background: linear-gradient(to bottom, red, #900);';
            break;
        case 'danger':
            icon = '<svg xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 0 24 24" width="48px" fill="white"><path d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/></svg>';
            durationcolor = '--duration: ' + duration + ';background: linear-gradient(to bottom, green, #090);';
            break;
        case 'warning':
            icon = '<svg xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 0 24 24" width="48px" fill="white"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/></svg>';
            durationcolor = '--duration: ' + duration + ';background: linear-gradient(to bottom, green, #090);';
            break;

        default:
            icon = '<svg xmlns="http://www.w3.org/2000/svg" height="48px" viewBox="0 0 24 24" width="48px" fill="white">' +
                '<path d="M0 0h24v24H0V0z" fill="none"/><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm4.59-12.42L10 14.17l-2.59-2.58L6 13l4 4 8-8z"/>' +
                '</svg>';
            durationcolor = '--duration: ' + duration + ';background: linear-gradient(to bottom, red, #900);';

    }


    if (mode === 'mulitlanguage') {
        notification.innerHTML = '' +
            '<div class="divTable">\n' +
            '<div class="divTableBody">\n' +
            '<div class="divTableRow">\n' +
            '<div class="divTableCell" style="vertical-align: middle;">' +
            icon +
            '</div>\n' +
            '<div class="divTableCell"><h4><strong>' + IntlMessage({
                messageId: title['messageId'],
                locale: title['locale']
            }) + '</strong></h4><p>' + IntlMessage({
                messageId: text['messageId'],
                locale: text['locale']
            }) + '</p></div>\n' +
            '</div>\n' +
            '</div>\n' +
            '</div>' +
            '' +
            '<div class="round-time-bar" data-style="smooth" style="'+durationcolor+'"><div></div></div>';
    } else {
        notification.innerHTML =
            '' +
            '<div class="divTable">\n' +
            '<div class="divTableBody">\n' +
            '<div class="divTableRow">\n' +
            '<div class="divTableCell" style="vertical-align: middle;">' +
            icon +
            '</div>\n' +
            '<div class="divTableCell"><h4><strong>' + title.text + '</strong></h4><p>' + text['text'] + '</p></div>\n' +
            '</div>\n' +
            '</div>\n' +
            '</div>' +
            '' +
            '<div class="round-time-bar" data-style="smooth" style="'+durationcolor+'"><div></div></div>';

    }


    let body = document.getElementsByTagName('body')[0];
    body.prepend(notification)
    setTimeout(CloseNotification, duration * 1000,reload,rewrite,landingpages);

}

const CloseNotification = (reload,rewrite,landingpages) => {

    document.querySelector('.alert-box').remove();
    if(reload === true) {
        window.location.reload()
    } else if(rewrite === true) {
        window.location.href = landingpages
    }
}


export const Notification = (props) => {
    setNotifcation(props.type, props.mode, props.title, props.text, props.insert, props.duration,props.reload,props.rewrite,props.landingpages)
}






